var ABClub = /** @class */ (function () {
    function ABClub() {
        this.card = '';
    }
    return ABClub;
}());
export default ABClub;
